export default __webpack_public_path__ + "static/media/tictactoe.20dc6773.png";